<template>
  <div class="body-bg">
    <div class="pay-container">
      <div class="step">
        <StepNumber align="right" :current="2" chooseType="confirm">
          <StepCommit :index="1">1.我的购物车</StepCommit>
          <StepCommit :index="2">2.填写核对订单信息</StepCommit>
          <StepCommit :index="3">3.成功提交订单</StepCommit>
        </StepNumber>
      </div>
      <div class="alert">
        <Icon type="checkmark-circled" class="checkmark"></Icon>
        <div class="tip">请您及时付款，以便订单尽快处理！</div>
        <div class="time">
          请您在提交订单后<span>2小时</span>内完成支付，否则订单会自动取消。
        </div>
      </div>
      <div class="pay-box">
        <div class="title">
          <strong>{{
            $route.params.method === "weixin" ? "微信支付" : "支付宝支付"
          }}</strong>
          <span>应该支付金额</span>
          <span v-if="price">￥{{ price }}</span>
        </div>
        <div class="pay-code">
          <div class="pay-code--left">
            <img src="@/assets/pc/images/pay/pay-demo.jpg" />
          </div>
          <div class="pay-code--right">
            <div class="title">
              {{
                $route.params.method === "weixin"
                  ? "使用微信扫一扫即可付款"
                  : "使用支付宝扫一扫即可付款"
              }}
            </div>
            <div class="tip">扫码支付</div>
            <div class="img">
              <img :src="imgSrc" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow">
      <div class="content">
        <div class="title">
          <img src="@/assets/pc/images/pay/success.png" alt="" />
          <span class="success">付款成功</span>
        </div>
        <div class="time">
          <span class="second">{{ num }}s</span>
          后跳转至订单详情...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepNumber from "@/components/pc/commonTool/Steps/StepNumber";
import StepCommit from "@/components/pc/commonTool/Steps/StepCommit";
import { orderDetail } from "@api/order";
export default {
  name: "Pay",
  components: {
    StepNumber,
    StepCommit
  },
  data() {
    return {
      imgSrc: "",
      orderId: "",
      num: 3,
      maskShow: false,
      price: 0
    };
  },
  methods: {
    waitPay() {
      orderDetail(this.orderId)
        .then(res => {
          const paid = res.data.paid;
          this.price = res.data.pay_price;
          if (paid === 1) {
            this.maskShow = true;
            this.timer = setInterval(() => {
              this.num--;
              if (this.num === 0) {
                this.$router.push({
                  path: "/home/orderDetail/" + this.orderId
                });
              }
            }, 1000);
          }
        })
        .catch(err => {
          this.$Modal.warning({
            content: err.msg,
            onOk: () => {
              this.$router.go(-1);
            }
          });
        });
    }
  },
  created() {
    this.imgSrc = "https://www.atropin.cn/" + this.$route.params.img;
    this.orderId = this.$route.params.orderId;
  },
  mounted() {
    this.myInterval = window.setInterval(() => {
      this.waitPay(); // 调用接口的方法
    }, 2000);
  },
  destroyed() {
    clearInterval(this.myInterval);
    clearInterval(this.timer);
  }
};
</script>
<style lang="stylus" scoped>
.body-bg
  background #fff
  .pay-container
    margin 0 auto
    width 990px
    padding 30px 0
    .step
      margin-bottom 20px
    .alert
      background #f3fded
      padding 20px 20px 20px 45px
      position relative
      .checkmark
        position absolute
        top 22px
        left 22px
        font-size 18px
        color #7ABD54
      .tip
        color #7ABD54
        font 14px/150% Arial
      .time
        margin-top 3px
        color #999
        span
          color #FF6600
    .pay-box
      margin-top 15px
      height 500px
      padding 20px
      border 5px solid #EAEAEA
      .title
        strong
          font: 20px "microsoft yahei"
          color #333
          font-weight 700
          margin-right 10px
        span
          &:first-child
            font-size 12px
          &:last-child
            margin-left 10px
            color #f54343
            font: 20px "microsoft yahei"
      .pay-code
        width 600px
        margin 30px auto 0
        display flex
        &--left
          width 300px
          img
            width 100%
        &--right
          width 300px
          text-align center
          .title
            font-size 16px
            color #333
            font-family "microsoft yahei"
          .tip
            margin-top 10px
          .img
            margin 0 auto
            margin-top 10px
            width 130px
            height 130px
            img
              width 100%
.mask
  position fixed
  top 0
  background rgba(0, 0, 0, 0.5)
  left 0
  right 0
  bottom 0
  display flex
  align-items center
  justify-content center
  .content
    width 300px
    height 150px
    background #fff
    padding 30px
    border-radius 8px
    .title
      text-align center
      img
        width 24px
        height 24px
        display inline-block
        position relative
        top 6px
      .success
        font-size 18px
        margin-left 5px
    .time
      margin-top 25px
      text-align center
      font-size 14px
      .second
        color rgb(252, 24, 24)
</style>
